import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/** Map /operate/incidents/:id/* → /operate/incidents?incident=:id */
export default function LegacyIncidentQueryRedirect() {
  const { incidentId = '', projectId = '' } = useParams();
  const params = new URLSearchParams();
  if (incidentId) params.set('incident', incidentId);
  const base = projectId
    ? `/projects/${projectId}/operate/incidents`
    : '../incidents';
  const qs = params.toString();
  return <Navigate to={`${base}${qs ? `?${qs}` : ''}`} replace />;
}

/** /operate/incident?incident= → /operate/incidents?incident= */
export function IncidentTabRedirect() {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  params.delete('section');
  const qs = params.toString();
  return <Navigate to={`../incidents${qs ? `?${qs}` : ''}`} replace />;
}
